import React from 'react'

export const CategoriaHubSectionSettings = (settingsProps) => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  )
}

export const CategoriaHubSectionFloatingSettings = () =>
  React.createElement(CategoriaHubSectionSettings, { floating: true })
